import React from "react";
import PropTypes from "prop-types";
import Table from "../../../../common/components/Table/Table";
import {Link} from "react-router-dom";
import MARVEL from "../../../../common/utils/MarvelUrls";
import SOURCE_TYPES from "../../../../common/resources/sourcetypes.json"
import COUNTRIES from "../../../../common/resources/countries.json"
import _ from "lodash";

export default class ServiceDetailDataSourcesTable extends React.Component {

    static propTypes = {
        resourceType: PropTypes.string,
        dpSources: PropTypes.array,
    }

    render() {

        return(
            <div className="associated-sources-table">
                <h2>Data Sources</h2>
                <div className="sticky-table-container">
                    <Table>
                        {this.props.dpSources.map(source => {
                            const sourceID = source.source_id;
                            const sourceType = _.result(_.find(SOURCE_TYPES, {
                                value: source.source_type
                            }), "label");
                            const sourceCountry = _.result(_.find(COUNTRIES, {
                                    value: source.country_iso
                                }), "label");
                            return (
                                <tr key={sourceID}>
                                    <td>
                                        <Link to={{
                                            pathname: MARVEL.VERITAS.data_sources
                                                + this.props.resourceType + "/" + sourceID
                                        }}
                                              key={sourceID}
                                        >
                                            <span>{sourceCountry}{" - "}{sourceType} {" "} {source.source_type_identifier}</span>
                                        </Link>
                                    </td>
                                    <td>
                                        {"Coverage: "}{source.overall_coverage}{source.coverage_type}
                                        <br/>
                                        <p>{source.status}</p>
                                    </td>
                                </tr>
                            );
                        })}
                    </Table>
                </div>
            </div>
        );
    }
}
